<div class="d-flex" style="position: relative;">
    <!-- <eap-input style="width: 500px;" (buttonClickEvent)="onAdvanceSearchButtonClick()" textButtonLabel="Advanced search"
        [allowToShowPlaceHolder]="true" placeholder="Start typing" [showTextButton]="true"
        textButtonClass="advance-search-button" (inputEvent)="searchTermChanged($event)" (focusEvent)="isFocused = true; showRecentlyViewed()"
        (blurEvent)="isFocused = false;" [showSearchIcon]="true" [isLoading]="isLoading" [isSearchGrey]="!isLoading && quickSearchCategoryItems.length > 0">
    </eap-input> -->

    <div class="searchForm">
        <div class="searchForm-wrap">
        <input type="text" autocomplete="off" class="searchForm-wrap-field shadow-none" tabindex="-1"
          placeholder="Start typing" name="search2" (input)="searchTermChanged($event)" (focus)="isFocused = true; showRecentlyViewed()"
           />
        
          <!-- <quick-search-popup class="quick-search-popup" [showSearchResults]="isQuickSearchShown"
            [searchTextInput]="searchText$" [showRecentlyViewedOnly]="isRecentlyViewedShown"
            (hideAndResetQuickSearch)="hideAndResetQuickSearch()" (loadingTrigger)="setLoading($event)">
          </quick-search-popup> -->
          @if (!isLoading) {
            <img class="searchForm-wrap-icon" src="assets/search.svg" alt="search"
              draggable="false" />
          } @else {
            <img class="searchForm-wrap-loader" src="assets/ellipse.svg" alt="loader" draggable="false" />
          }
          <button class="searchForm-wrap-btn" type="button" tabindex="-1" title=""
          (click)="onAdvanceSearchButtonClick()">
            <!--{{ powerSearchTooltip }}  -->
            Advanced search
          </button>
        </div>
    </div>

    <div class="quick-search-list" *ngIf="isSearchResultOpen" [ngClass]="{'loading' : isLoading}" (click)="$event.stopPropagation()">

        <ng-container *ngIf="isLoading">
            <img class="loader" src="assets/ellipse.svg" alt="loader" draggable="false" />
        </ng-container>        

        <span *ngIf="quickSearchCategoryItems.length > 0 || quickSearchRecentlyViewedItems.length > 0">
            <!-- <div class="category-container">
                <div *ngFor="let cat of quickSearchCategory" (click)="cat.Count === 0 ? null : onSelectCategory(cat.Key)"
                    class="category-container-item" [class.active]="selectedCategory === cat.Key"
                    [class.disabled]="cat.Count === 0">
                    {{cat.Name}} ({{cat.Count}})
                </div>
            </div> -->
            <div *ngIf="shownRecentlyViewedItems.length > 0" class="row pe-1 mt-2">
                <div class="results-text">
                    {{ viewedResultsMessage }}
                </div>
                <div class="col-12 search-result-container recently-viewed-result-container"
                    [ngClass]="(searchText && searchText.length > 2 ? 'recently-viewed-result-container-fixed' : '')">                    
                    <div class="dropdown-list-content">                        
                        <div class="row grey-border-b quick-search-item" *ngFor="let item of shownRecentlyViewedItems; let i = index">
                            <div class="col-0_5">
                                <img class="quick-search-item-wrap-icon" src="{{ getIconByCategoryType(item.CategoryType) }}" />
                                <!-- <mat-icon
                                    class="material-symbols-outlined text-mat-base-text me-3 mt-2 font-size-1.6rem">
                                    {{ item.ResultIcon }}
                                </mat-icon> -->
                            </div>
                            <div class="col-10">
                                <ng-container [ngSwitch]="item.CategoryType">
                                    <div *ngSwitchCase="QuickSearchCategory.person" class="info-block cursor-pointer" (click)="onQuickNavItemClick(item)">
                                         <div class="info-block-name">
                                            <div>
                                                <span class="info-block-name--prefix">(Person)</span>
                                                <span class="info-block-name--text" [title]="getTitleName(item?.PersonName)"
                                                    innerHTML="{{ item?.PersonName || '' }}"></span>
                                            </div>
                                        </div>
                                        <ng-container
                                            *ngTemplateOutlet="additionalFieldsBlock; context: { item: item }">
                                        </ng-container>
                                        <!-- <img class="icon" src="assets/time-entry.svg" alt="time-icon" draggable="false" /> -->
                                    </div>
                                    <div *ngSwitchCase="QuickSearchCategory.officer" class="info-block d-flex cursor-pointer" (click)="onQuickNavItemClick(item)">
                                        <div class="info-block-name">
                                            <div>
                                                <span class="info-block-name--prefix">(Officer)</span>
                                                <span class="info-block-name--text" [title]="getTitleName(item?.PersonName)"
                                                innerHTML="{{ item?.PersonName || '' }}"></span>
                                            </div>
                                            <div>
                                                <span class="info-block-name--prefix">Agency:</span>
                                                <span class="info-block-name--text" [title]="getTitleName(item?.Agency)"
                                                innerHTML="{{ item?.Agency || '' }}"></span>
                                            </div>
                                        </div>
                                        <ng-container
                                            *ngTemplateOutlet="additionalFieldsBlock; context: { item: item }">
                                        </ng-container>
                                        <!-- <img class="icon" src="assets/time-entry.svg" alt="time-icon" draggable="false" /> -->
                                    </div>
                                    <div *ngSwitchCase="QuickSearchCategory.crimcase" class="info-block cursor-pointer" (click)="onQuickNavItemClick(item)">
                                        <div class="info-block-name">
                                            <div>
                                                <span class="info-block-name--prefix">(Crim.)</span>
                                                <span class="info-block-name--prefix">File #:</span>
                                                <span class="info-block-name--text"
                                                    [title]="getTitleName(getFormattedFileNo(item))"
                                                    innerHTML="{{ getFormattedFileNo(item) || '' }}"></span>
                                            </div>
                                            <div>
                                                <span class="info-block-name--prefix">Defendant name:</span>
                                                <span class="info-block-name--text" [title]="getTitleName(item?.PersonName)"
                                                    innerHTML="{{ item?.PersonName || '' }}"></span>
                                            </div>
                                        </div>
                                        <ng-container
                                            *ngTemplateOutlet="additionalFieldsBlock; context: { item: item }">
                                        </ng-container>
                                        <!-- <img class="icon" src="assets/time-entry.svg" alt="time-icon" draggable="false" /> -->
                                    </div>
                                    <div *ngSwitchCase="QuickSearchCategory.civilcase" class="info-block" (click)="onQuickNavItemClick(item)">
                                        <div class="info-block-name">
                                            <div>
                                                <span class="info-block-name--prefix">(Civil.)</span>
                                                <span class="info-block-name--prefix">File #:</span>
                                                <span class="info-block-name--text"
                                                    [title]="getTitleName(getFormattedFileNo(item))"
                                                    innerHTML="{{ getFormattedFileNo(item) || '' }}"></span>
                                            </div>
                                            <div>
                                                <span class="info-block-name--prefix">Matter:</span>
                                                <span class="info-block-name--text" [title]="getTitleName(item?.Matter)"
                                                    innerHTML="{{ item?.Matter || '' }}"></span>
                                            </div>
                                        </div>
                                        <ng-container
                                            *ngTemplateOutlet="additionalFieldsBlock; context: { item: item }">
                                        </ng-container>
                                        <!-- <img class="icon" src="assets/time-entry.svg" alt="time-icon" draggable="false" /> -->
                                    </div>

                                </ng-container>
                            </div>
                            <div class="col-0_5">
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="quickSearchCategoryItems.length > 0" class="row pe-1 mt-3">
                <div class="results-text">
                    Results Shown/Total {{quickSearchCategoryItems.length}}/{{totalAmount}}
                </div>
                <div class="col-12 search-result-container">                    
                    <div class="dropdown-list-content">                        
                        <div class="row grey-border-b" *ngFor="let item of quickSearchCategoryItems; let i = index">
                            <div class="col-0_5">
                                <img class="quick-search-item-wrap-icon" src="{{ getIconByCategoryType(item.CategoryType) }}" />
                                <!-- <mat-icon
                                    class="material-symbols-outlined text-mat-base-text me-3 mt-2 font-size-1.6rem">
                                    {{ item.ResultIcon }}
                                </mat-icon> -->
                            </div>
                            <div class="col-10">
                                <ng-container [ngSwitch]="item.CategoryType">
                                    <div *ngSwitchCase="QuickSearchCategory.person" class="info-block cursor-pointer" (click)="onQuickNavItemClick(item)">
                                        <div class="info-block-name">
                                            <div>
                                                <span class="info-block-name--prefix">(Person)</span>
                                                <span class="info-block-name--text" [title]="getTitleName(item?.PersonName)"
                                                    innerHTML="{{ item?.PersonName || '' }}"></span>
                                            </div>
                                        </div>
                                        <ng-container
                                            *ngTemplateOutlet="additionalFieldsBlock; context: { item: item }">
                                        </ng-container>
                                    </div>
                                    <div *ngSwitchCase="QuickSearchCategory.officer" class="info-block d-flex cursor-pointer" (click)="onQuickNavItemClick(item)">
                                        <div class="info-block-name">
                                            <div>
                                                <span class="info-block-name--prefix">(Officer)</span>
                                                <span class="info-block-name--text" [title]="getTitleName(item?.PersonName)"
                                                innerHTML="{{ item?.PersonName || '' }}"></span>
                                            </div>
                                            <div>
                                                <span class="info-block-name--prefix">Agency:</span>
                                                <span class="info-block-name--text" [title]="getTitleName(item?.Agency)"
                                                innerHTML="{{ item?.Agency || '' }}"></span>
                                            </div>
                                        </div>
                                        <ng-container
                                            *ngTemplateOutlet="additionalFieldsBlock; context: { item: item }">
                                        </ng-container>

                                    </div>
                                    <div *ngSwitchCase="QuickSearchCategory.crimcase" class="info-block cursor-pointer" (click)="onQuickNavItemClick(item)">
                                        <div class="info-block-name">
                                            <div>
                                                <span class="info-block-name--prefix">(Crim.)</span>
                                                <span class="info-block-name--prefix">File #:</span>
                                                <span class="info-block-name--text"
                                                    [title]="getTitleName(getFormattedFileNo(item))"
                                                    innerHTML="{{ getFormattedFileNo(item) || '' }}"></span>
                                            </div>
                                            <div>
                                                <span class="info-block-name--prefix">Defendant name:</span>
                                                <span class="info-block-name--text" [title]="getTitleName(item?.PersonName)"
                                                    innerHTML="{{ item?.PersonName || '' }}"></span>
                                            </div>
                                        </div>
                                        <ng-container
                                            *ngTemplateOutlet="additionalFieldsBlock; context: { item: item }">
                                        </ng-container>
                                    </div>
                                    <div *ngSwitchCase="QuickSearchCategory.civilcase" class="info-block" (click)="onQuickNavItemClick(item)">
                                        <div>
                                            <span class="info-block-name--prefix">(Civil.)</span>
                                            <span class="info-block-name--prefix">File #:</span>
                                            <span class="info-block-name--text"
                                                [title]="getTitleName(getFormattedFileNo(item))"
                                                innerHTML="{{ getFormattedFileNo(item) || '' }}"></span>
                                        </div>
                                        <div>
                                            <span class="info-block-name--prefix">Matter:</span>
                                            <span class="info-block-name--text" [title]="getTitleName(item?.Matter)"
                                                innerHTML="{{ item?.Matter || '' }}"></span>
                                        </div>
                                        <ng-container
                                            *ngTemplateOutlet="additionalFieldsBlock; context: { item: item }">
                                        </ng-container>
                                    </div>

                                </ng-container>
                            </div>
                            <div class="col-0_5">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </span>

        <div class="quick-search-notfound" *ngIf="!isLoading && searchText && searchText.length > 2 && quickSearchCategoryItems.length === 0">
            <div class="quick-search-notfound-container d-flex">
                <img class="quick-search-notfound-container-icon" src="assets/question-mark.svg" alt="question-mark"
                    draggable="false" />
                <div class="no-results-text"> No data with "{{searchText}}" match has found </div>
            </div>
        </div>
    </div>
</div>

<ng-template #additionalFieldsBlock let-item="item">
    <ng-container *ngIf="item">
        <div class="info-block-small-block">
            <div *ngIf="item.Court">
                <span class="info-block-small-block--prefix">Court #:</span>
                <span class="info-block-small-block--text" [title]="getTitleName(item?.Court)"
                    innerHTML="{{ item?.Court || '' }}"></span>
            </div>
            <div *ngIf="item.Report">
                <span class="info-block-small-block--prefix">Report #:</span>
                <span class="info-block-small-block--text" [title]="getTitleName(item?.Report)"
                    innerHTML="{{ item?.Report || '' }}"></span>
            </div>
            <div *ngIf="item.DOB">
                <span class="info-block-small-block--prefix">DOB:</span>
                <span class="info-block-small-block--text" [title]="getTitleName(item.DOB)"
                    innerHTML="{{ item.DOB || '' }}"></span>
            </div>
            <div *ngIf="item.SSN">
                <span class="info-block-small-block--prefix">SSN:</span>
                <span class="info-block-small-block--text" [title]="getTitleName(item.SSN)"
                    innerHTML="{{ item.SSN || '' }}"></span>
            </div>
            <div *ngIf="item.DSN">
                <span class="info-block-small-block--prefix">DSN:</span>
                <span class="info-block-small-block--text" [title]="getTitleName(item.DSN)"
                    innerHTML="{{ item.DSN }}"></span>
            </div>
            <div *ngIf="item.Agency && item.CategoryType === QuickSearchCategory.officer">
                <span class="info-block-small-block--prefix">Agency:</span>
                <span class="info-block-small-block--text" [title]="getTitleName(item.Agency)"
                    innerHTML="{{ item.Agency }}"></span>
            </div>
            <div *ngIf="item.Address">
                <span class="info-block-small-block--prefix">Address:</span>
                <span class="info-block-small-block--text" [title]="getTitleName(item.Address)"
                    innerHTML="{{ item.Address }}"></span>
            </div>
            <div *ngIf="item?.LeadCharge && item.CategoryType === QuickSearchCategory.crimcase">
                <span class="info-block-small-block--prefix">Lead charge:</span>
                <span class="info-block-small-block--text" [title]="getTitleName(item?.LeadCharge)"
                    innerHTML="{{ item?.LeadCharge || '' }}"></span>
            </div>
            <div *ngIf="item?.CivilMatter && item.CategoryType === QuickSearchCategory.civilcase">
                <span class="info-block-small-block--prefix">Civil matter:</span>
                <span class="info-block-small-block--text" [title]="getTitleName(item?.CivilMatter)"
                    innerHTML="{{ item?.CivilMatter || '' }}"></span>
            </div>
            <div *ngIf="item.TerminationDate && item.CategoryType === QuickSearchCategory.officer">
                <span class="info-block-small-block--prefix">DOT:</span>
                <span class="info-block-small-block--text" [title]="getTitleName(item.TerminationDate)"
                    innerHTML="{{ formatTerminationDate(item.TerminationDate) }}"></span>
            </div>
            <div *ngIf="item.Rank && item.CategoryType === QuickSearchCategory.officer">
                <span class="info-block-small-block--prefix">Rank:</span>
                <span class="info-block-small-block--text" [title]="getTitleName(item.Rank)"
                    innerHTML="{{ item.Rank }}"></span>
            </div>
        </div>
    </ng-container>
</ng-template>